export const _osTrackingEvent = paramObj => {
  try {
    if (typeof window !== "undefined") {
      window._osHyundaiEvents(paramObj);
    }
  } catch (err) {}
};
